import { styled, Tooltip, Typography, TypographyProps } from '@mui/material';
import { FC, ReactNode } from 'react';

const StyledTypography = styled(Typography)({
  textDecoration: 'underline',
  textDecorationStyle: 'dotted',
  cursor: 'default',
});

interface Props extends TypographyProps {
  tooltip: ReactNode;
}

const TooltipTypography: FC<Props> = ({ tooltip, children, ...props }) => (
  <Tooltip arrow title={tooltip}>
    <StyledTypography tabIndex={0} {...props}>
      {children}
    </StyledTypography>
  </Tooltip>
);

export default TooltipTypography;
